<template>
  <div class="d-flex align-items-center">
    <div class='' :id='data.selector'></div>
  </div>
</template>

<script>
import * as d3 from 'd3v4'

export default {
  name: '',
  props: ['data'],
  mounted () {
    this.setChart()
  },
  computed: {
    total: function () {
      return 649
    }
  },
  methods: {
    setChart: function () {
      let vm = this
      let width = 100
      let height = 100
      const chartData = this.data.dataSet

      const margin = {top: 0, right: 0, bottom: 0, left: 0}
      width = width - margin.left - margin.right
      height = height - margin.top - margin.bottom

      this.svgChart = d3.select('#' + this.data.selector)
        .append('svg')
        .attr('width', '100%')
        .attr('height', height + margin.top + margin.bottom)
        .attr('viewBox', '0 0 ' + width + ' ' + height)
        .append('g')
        .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')

      let radius = Math.min(width, height) / 2
      let arc = d3.arc().outerRadius(radius - 10).innerRadius(0)

      let pie = d3.pie().sort(function (d) { return d }).value(function (d) { return d })

      let g = this.svgChart.selectAll('.arc')
        .data(pie(chartData))
        .enter().append('g')
        .attr('class', 'arc')

      g.append('path')
        .attr('d', arc)
        .style('fill', function (d, i) {
          return vm.data.colors[i]
        })
        .style('stroke', '#243447')
        .style('stroke-width', '2px')
    }
  }
}
</script>

<style scoped>
  .arc path {
    stroke: #ff9900;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/charts/BinaryPieChart.vue